import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M95.113 50.523a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M72.977 6.545a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 0 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M60.861 6.545a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 0 1-2.122 2.121l-9.994-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path fill="#D8FFFF" d="M80.5 100a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M18.067 78.868a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V80.368a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M9.5 87.436a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H11a1.5 1.5 0 0 1-1.5-1.5M97 88a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M42.892 24.065a2.59 2.59 0 0 1 2.591 2.591v10.899a2.591 2.591 0 1 1-5.182 0V26.656a2.59 2.59 0 0 1 2.591-2.591M73.514 24.065a2.59 2.59 0 0 1 2.592 2.591v10.899a2.592 2.592 0 0 1-5.183 0V26.656a2.59 2.59 0 0 1 2.591-2.591M58.203 73.026a2.59 2.59 0 0 1 2.592 2.592v9.296c0 12.088-9.8 21.887-21.888 21.887a2.591 2.591 0 1 1 0-5.183c9.226 0 16.705-7.478 16.705-16.704v-9.296a2.59 2.59 0 0 1 2.591-2.592"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M33.475 57.78c2.121 10.185 11.145 17.838 21.959 17.838h5.539c10.814 0 19.838-7.654 21.959-17.838z"
    />
    <path
      fill="#00D8D8"
      d="M83.406 53.184V39.883a4.634 4.634 0 0 0-4.634-4.634H37.634A4.634 4.634 0 0 0 33 39.883v13.301c0 1.576.166 3.112.475 4.595h49.457c.309-1.484.474-3.02.474-4.595"
    />
  </svg>
);
const SvgEnrichedIconElectricalBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconElectricalBrand);
export default Memo;
